<!--
 * @Desc: 业务员的二级分销商
 * @Author: may.li
 * @Date: 2023-03-09 08:59:42
 * @LastEditors: may.li
 * @LastEditTime: 2023-06-12 09:07:15
-->
<template>
	<div class="page page_fans page_adress">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
			<div class="list">
				<div class="item" v-for="(item,index) in dataList" :key="index">
					<div class="item_l">
						<img :src="item.agent_thumb ? ($publicData.withHttpStart(item.agent_thumb) ? item.agent_thumb : imageUrl+item.agent_thumb) : $publicData.defaultTouxiang" alt="" class="thumb">
						<div class="user_name slh_s">{{ item.agent_name }}</div>
					</div>
					<div class="scane-btn" v-if="status == 1" @click.stop="scaneCode(item.agent_uuid)">扫一扫</div>
				</div>
			</div>
		</van-list>
		<van-overlay :show="showPingyao">
			<div class="pingyao-wrap">
				<div class="py-name">绑定成功，是否进入小程序查看？</div>
				<div class="py-action">
					<div class="py-confirm ac-cancle" @click="cancelLook">否</div>
					<div class="py-confirm" style="position: relative;">
						<span>是</span>
						<wx-open-launch-weapp id="ymweapp" username="gh_0e1240455bda" :path="'pages/citypartner/index?agent_uuid='+bindAgentUuid">
							<script type="text/wxtag-template">
								<style>.ymweapp-tu {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
								<div class="ymweapp-tu"></div>
							</script>
						</wx-open-launch-weapp>
					</div>
				</div>
			</div>
		</van-overlay>
		<!-- 二次确认 -->
		<van-overlay :show="showSecConfirm">
			<div class="sec-confirm">
				<div class="confirm-name">是否确认绑定？</div>
				<div class="beizhu-wrap">
					<span class="beizhu-text">备注：</span>
					<van-field v-model="remark" :border="false" placeholder="请输入" />
				</div>
				<div class="confirm-actions">
					<div class="confirm-btn ac-cancle" @click="showSecConfirm = false;">取消</div>
					<div class="confirm-btn" @click="confirmBind">确认</div>
				</div>
			</div>
		</van-overlay>
	</div>
</template>
<script>

export default {
	data(){
		return{
			token: null,
			status: null, // 此业务员状态 1正常 2禁用;禁用不可扫码
			first_agent_uuid: null, // 此业务员所属的一级分销商
			page: 1,
			size: 10,
			dataList: [],
			loading: false,
			finished: false,
			showPingyao: false,
			pingyaoCode: null,
			bindAgentUuid: null,
			showSecConfirm: false, // 绑定 二次确认
			remark: null, // 绑定时需填写备注
			imageUrl: this.$publicData.uploadImage
		}
	},
	created(){
		this.token = this.$store.getters.token;
		this.status = this.$route.query.status;
		this.first_agent_uuid = this.$route.query.first_agent_uuid;
	},
	mounted(){
		let that = this;
		let btn = document.getElementById('ymweapp');
		btn.addEventListener('launch', function (e) {
			console.log('跳转小程序success');
			that.showPingyao = false;
		});
		btn.addEventListener('error', function (e) {
			console.log('跳转小程序fail', e.detail);
		});
	},
	methods: {
		/**
		 * @name: 绑定成功,但不查看
		 * @return {*}
		 * @desc: 
		 */		
		cancelLook(){
			this.showPingyao = false;
			this.page = 1;
			this.loading = true;
			this.finished = false;
			this.dataList = [];
			this.getData();
		},
		/**
		 * @name: 确认绑定
		 * @return {*}
		 * @desc: 
		 */		
		confirmBind(){
			if(!this.remark){
				this.$toast("备注必须填写");
				return;
			}
			this.showSecConfirm = false;
			this.bindCode();
		},
		/**
		 * @name: 绑定
		 * @return {*}
		 * @desc: 
		 */		
		bindCode(){
			let that = this;
			let params = {
				token: this.token,
				qrcode_num: this.pingyaoCode,
				agent_uuid: this.bindAgentUuid,
				mark: this.remark
			};
			this.$api.salesman.bindqrcode(params).then(res=>{
				if(res.code == 200){
					// 不再跳转小程序
					// that.showPingyao = true;
				}else{
					this.$toast(res.message);
				}
			})
		},
		/**
		 * @name: 验证业务员是否能给二级分销商绑码
		 * @param {*} code
		 * @param {*} agent_uuid
		 * @return {*}
		 * @desc: 包含业务员是否能绑、码可不可用
		 */		
		verfyCode(code,agent_uuid){
			let that = this;
			let params = {
				token: this.token,
				qrcode_num: code
			};
			this.$api.salesman.verifyqrcode(params).then(res=>{
				if(res.code == 200){
					that.showSecConfirm = true;
					that.remark = null;
					that.pingyaoCode = code;
					that.bindAgentUuid = agent_uuid;
				}else{
					this.$toast(res.message);
				}
			})
		},
		/**
		 * @name: 绑定分销商
		 * @param {*} agent_uuid
		 * @return {*}
		 * @desc: 
		 */		
		scaneCode(agent_uuid){
			let that = this;
			wx.scanQRCode({
				needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
				scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
				success: function(res) {
					console.log('扫码成功res',res);
					let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
					let params = that.$util.getUrlParams(result);
					if(params.pingyaoqrcodenum){
						let code = params.pingyaoqrcodenum;
						// 验证此码是否可用
						that.verfyCode(code,agent_uuid);
					}else{
						that.$toast('二维码有误，请联系相关人员');
					}
				},
				fail: function(err) {
					that.$toast('扫码失败');
					console.log('调扫码失败，'+ err);
				}
			});
		},
		/**
		 * @name: 跳转分销商的二维码
		 * @param {*} item
		 * @return {*}
		 * @desc: 让屏蔽入口了,暂时无用
		 */		
		toAgentMa(item){
			this.$router.push({
				path: "/salesman/agent/allma",
				query: {
					agent_uuid: item.agent_uuid
				}
			})
		},
		/**
		 * @name: 获取数据
		 * @return {*}
		 * @desc: 
		 */		
		getData(){
			let params = {
				token: this.token,
				first_agent_uuid: this.first_agent_uuid,
				page: this.page,
				size: this.size
			};
			this.$api.salesman.agentlist(params).then(res=>{
				if(res.code == 200){
					let list = res.result;
					if(list && list.length){
						for(let i in list){
							this.dataList.push(list[i]);
						};
						if(list.length < this.size){
							this.finished = true;
						}else{
							this.page++;
							this.loading = false;
						}
					}else{
						this.finished = true;
					}
				}else{
					this.finished = true;
					this.$toast(res.message);
				}
			})
		}
	},
}
</script>
<style scoped>
	.pingyao-wrap{
		width: 8rem;
		border-radius: .4rem;
		background: #ffffff;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		padding: .4rem;
	}
	.pingyao-wrap .py-name{
		font-size: .4rem;
		text-align: center;
	}
	.pingyao-wrap .py-action{
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-top: 0.4rem;
		font-size: .38rem;
	}
	.pingyao-wrap .py-action .py-confirm{
		width: 2.67rem;
		height: 0.93rem;
		border-radius: 0.47rem;
		font-size: 0.4rem;
		text-align: center;
		line-height: 0.93rem;
		color: rgba(255, 255, 255, 1);
		background: linear-gradient( 90deg, rgba(223, 52, 52, 1), rgba(255, 95, 52, 1));
	}
	.pingyao-wrap .py-action .py-confirm.ac-cancle{
		background: rgba(0,0,0,.2);
	}
	.pingyao-wrap #ymweapp{
		width:100%;
		height:100%;
		position: absolute;
		top: 0;
		left: 0;
	}
	.sec-confirm{
		width: 8rem;
		border-radius: .4rem;
		background: #ffffff;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		padding: .4rem;
	}
	.sec-confirm .confirm-name{
		font-size: .4rem;
		text-align: center;
	}
	.sec-confirm .confirm-actions{
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-top: 0.4rem;
		font-size: .38rem;
	}
	.sec-confirm .confirm-actions .confirm-btn{
		width: 2.67rem;
		height: 0.93rem;
		border-radius: 0.47rem;
		font-size: 0.4rem;
		text-align: center;
		line-height: 0.93rem;
		color: rgba(255, 255, 255, 1);
		background: linear-gradient( 90deg, rgba(223, 52, 52, 1), rgba(255, 95, 52, 1));
	}
	.sec-confirm .confirm-actions .confirm-btn.ac-cancle{
		background: rgba(0,0,0,.2);
	}
	.scane-btn{
		padding: 0 0.24rem;
		height: 0.67rem;
		text-align: center;
		line-height: 0.67rem;
		font-size: 0.35rem;
		color: rgba(211, 68, 68, 1);
		border-radius: 0.33rem;
		border: 0.0267rem solid rgba(211, 68, 68, 1);
	}
	.sec-confirm .beizhu-wrap{
		display: flex;
    	align-items: flex-end;
		height: 0.77rem;
		line-height: 0.77rem;
		margin-top: 0.2rem;
	}
	.sec-confirm .beizhu-wrap .van-cell{
		width: auto;
		padding: 0;
		line-height: unset;
		border-bottom: 0.0134rem solid rgba(0,0,0,.1);
	}
</style>